'use strict';
import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy,
  OnInit
} from '@angular/core';
import { cloneDeep,isEmpty,isEqual,set, remove, has} from 'lodash';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { GroupingAndOrderingService } from '@ispm/shared/services/grouping-and-ordering.service';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { get, includes,every } from 'lodash';
import { DynamicFormTableComponent } from '@ispm/dynamic-form/components/dynamic-form-table/dynamic-form-table.component';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import {AbstractControl, AsyncValidator, FormGroup, ValidationErrors} from '@angular/forms';
import {Observable} from "rxjs/Observable";
import {of} from "rxjs/index";
import {EventService} from "@ispm-client/modules/events/services/event.service";
import {Subject, Subscription} from "rxjs";

enum EVENTS {
  DeleteEvent = 'DeleteEvent',
  CloneEvent = 'CloneEvent',
  ValidationEvent ='RowValidationEvent'
}

const selectionListId ='__gen-selection-list__unique-item-id__';
const UNIQUEPARAM = 'uniqueParam';
@Component({
  selector: 'gen-priority-table-container',
  templateUrl: 'priority-table.component.html',
  styleUrls: ['priority-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent()
export class PriorityTableComponent implements OnInit, AfterViewInit, OnDestroy, IWidgetItem {
  private static TAG_DELETED: string = 'deleted';
  public init: boolean = false;
  public dataInit: boolean =false;
  public hiddenFormItems: any = [];
  public widgetFormInstance:FormGroup;
  public widgetFormInstanceSubmitted : boolean;
  private addFormConfig:IdynamicFormItem[]
  itemName: string;
  validationStatus: Map<string,boolean> = new Map<string, boolean>();
  public isExternal: boolean =false;
  private eventSelectedSubscription: Subscription;
  private asyncDestroyer: Subject<any> = new Subject();
  private enableHardDelete: boolean = false;


  /**
   * set priority table config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem<PriorityTablePayload>) {
    this.appendFormId = _itemConfig.widgetPayload.appendFormId;
    this.itemFormId = _itemConfig.widgetPayload.itemFormId;
    this.group = _itemConfig.widgetPayload;
    this.group.orderBy = this.group.orderBy || 'ASC';
    this.prioritizeAvailable = _itemConfig.widgetPayload.prioritizeAvailable;
    this.editMode = _itemConfig.widgetPayload.editMode;
    this.popupMode = _itemConfig.widgetPayload.popupMode;
    this.listenToDataChange = _itemConfig.widgetPayload.listenToDataChange;
    this.buildWidgetConfiguration(_itemConfig);
    this.itemName = _itemConfig.name;
    this.handleIsExternalAttribute(_itemConfig);
    if(has(_itemConfig.widgetPayload, "enableHardDelete")){
      this.enableHardDelete = _itemConfig.widgetPayload.enableHardDelete;
    }




    // Get form config to get all labels of the form and pass it to dynamic form table
    // Filter all items which has class hidden-form-item
    this._formHandlerService.getStoredFormConfigs().pipe(
      map(formConfigs => {
        if (formConfigs.has(this.itemFormId)) {
          return formConfigs.get(this.itemFormId);
        } else {
          this._formHandlerService.getForm(this.itemFormId);
          return null;
        }
      }),
      filter(config => !!config),
      take(1)
    ).subscribe(formItem => {
      let formItems = formItem.filter(input => {
        return !includes(input['cssClass'], 'hidden-form-item');
      });

      let hiddenFormItems = formItem.filter(input => {
        return includes(input['cssClass'], 'hidden-form-item');
      });
      let hiddenItems = {};
      hiddenFormItems.forEach(formItems => {
        if(formItems.name) {
          hiddenItems[formItems.name] = formItems.defaultValue;
          this.hiddenFormItems.push(hiddenItems);
        }
      });

      formItems.forEach(formItem => {
        if (formItem.label) {
          this.formTitles.push({ label: formItem.label});
        }
      });
    });

  }

  private handleIsExternalAttribute(_itemConfig: IdynamicFormItem<PriorityTablePayload>){
    let selectedEvent = {};
    this.eventSelectedSubscription = this._eventService.getSelectedEvent().pipe(takeUntil(this.asyncDestroyer.asObservable())).subscribe(data => {
      selectedEvent = data
    });
    if(has(_itemConfig.widgetPayload, "isExternal") &&
      (get(_itemConfig.widgetPayload, "isExternal") === true )
    ){
      if(has(selectedEvent, "id")){
        if(has(selectedEvent, "isExternal")){
          this.isExternal = get(selectedEvent, "isExternal");
        }
      }else{
        this.isExternal = true;
      }
    }
  }

  /**
   * set priority table data
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this.init = true;
    if (!isEmpty(widgetData) && !this.dataInit) {
      this._widgetData = widgetData;
      this.mapData(this._widgetData);
      this.dataInit = true;
    }
    else {
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
  }

  public submitted: boolean = false;
  public _widgetData: Array<object> = [];
  public formItems: any;
  public data: any[] = [];
  public configData: any[] = [];
  public itemOverrides: (item: any) => any;
  public approvedMode: boolean = false;
  public widgetUpdateValueCallback: (value) => void;
  public collapsed: boolean = false;
  public reset: boolean = false;
  public newItem: any = { };
  public group: any;
  public appendFormId: any;
  public itemFormId: any;
  public prioritizeAvailable: boolean;
  public listenToDataChange: boolean;
  public editMode: boolean;
  public popupMode: boolean;
  public formTitles: any[] = [];
  public isValid: boolean;
  public formTitlesTable: any = [];
  public addFormEditMode: boolean = false;

  private events = {
    [EVENTS.CloneEvent]: { removeCallbacks: [], callback: this.cloneCallback.bind(this)},
    [EVENTS.DeleteEvent]: { removeCallbacks: [], callback: this.deleteCallback.bind(this)},
    [EVENTS.ValidationEvent]:{removeCallbacks: [], callback: this.validationCallback.bind(this)}
  };

  constructor(private _groupingService: GroupingAndOrderingService,
              private _changeDetector: ChangeDetectorRef,
              public element: ElementRef,
              public _formHandlerService: FormHandlerService,
              private _eventService: EventService) { }


  ngOnInit() {
    this._formHandlerService.getForm(this.appendFormId).subscribe(formConfig=>{
      this.addFormConfig=formConfig.inputs;
    })
  }

  ngAfterViewInit(): void {
    // Handling delete and clone events when it's emitted from the dynamic form table
    const elements = this.element.nativeElement.querySelectorAll('.priority-tables-selector');
    for (const event in this.events) {
      elements.forEach(element => {
        const instance = element.addEventListener(event, this.events[event].callback, { passive: true});
        this.events[event].removeCallbacks.push(() => {
          element.removeEventListener(event, instance);
        });
      });
    }
  }

  ngOnDestroy() {
    if(this.eventSelectedSubscription){
      this.eventSelectedSubscription.unsubscribe();
    }

    for (const event in this.events) {
      this.events[event].removeCallbacks.forEach(callback => callback());
    }
    this._groupingService.notifyDataUpdated(false);
  }

  cloneCallback(event) {
    const cloneItem = (<any> event).detail;
    const newCloneItem = cloneDeep(cloneItem);
    delete cloneItem['id'];
    delete cloneItem['meta'];
    this._widgetData.push(newCloneItem);

    this.mapData(this._widgetData);

  }

  deleteCallback(event) {
    const deleteItem = (<any> event).detail;
    this.deleteItem(deleteItem);
  }

  validationCallback(event) {
    const validationItem = (<any> event).detail;
    this.validationStatus.set(validationItem.item[selectionListId],validationItem.valid);
    let uniqueIds :string[] = this._widgetData.map(item => item[selectionListId]);
    this.validationStatus.forEach((value, key ) => {
      if (uniqueIds.findIndex(id => id === key) < 0) {
        this.validationStatus.delete(key);
      }
    })
    this.emitUpdate();
  }

  mapData(data) {
    const formData: any = data;
    this.configData.length = 0;
    let groupArray;
    this.formTitlesTable = [];

    const asyncValidate = new PriorityTableValidator(() => {
      return Array.from(this.validationStatus.values()).every(v => v);
    });
    if(!this.widgetFormInstance.controls[this.itemName].asyncValidator){
      this.widgetFormInstance.controls[this.itemName].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
    }


    // Grouping the items and sorting the grouped items
    // Handling the number of items to display in each table based on configuration
    if (formData && this.group.groupBy && this.group.groupOrderAttribute && this.group.orderBy) {
      groupArray = this._groupingService.getGrouppedAndOrderedDataStructureEditMode(formData, this.group.groupBy, this.group.groupOrderAttribute, this.group.orderBy);
      this.formItems.forEach((config, index) => {
        this.configData.push(groupArray.slice(config.widgetPayload.startIndex, config.widgetPayload.endIndex));
        const titles = this.configData[index].length > 0 ? this.formTitles : [];
        this.formTitlesTable.push(titles);
      });
    }
    // this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  updateContainedData(dataArray: any[], index?: number) {
    // Calling mapData method to group the item when Group item has been changed.
    let groupItmChanged = false;
    const grouperItem =[];
    dataArray.forEach(data => {
      const groupItems = data.map(groupBy => groupBy[this.group.groupBy[0]]);
      const distinctObject = Array.from(new Set(groupItems.map(subGroup => subGroup[this.group.groupBy[1]])))
        .map(subGroup => {
          return subGroup;
        });
      if (distinctObject.length > 1) {
        groupItmChanged = true;
      } else if (distinctObject.length === 1) {
        /**
         * This is case where you would find each group might have single row and possibly that marker in different group
         * might have been changed to that of the some other group. Therefore group changing to re-run .
         */
        if (!isEmpty(grouperItem)) {
          const groupItemIndex = grouperItem.findIndex(groupItem => groupItem === distinctObject[0]);
          if (groupItemIndex > -1) {
            groupItmChanged = true;
          }
        }
        grouperItem.push(distinctObject[0]);
      }
    });

    this.configData[index] = dataArray;
    /**
     * This is required to remove duplication selection items. Duplicate selection items occurs
     * during rearranging of items between two priority tables.
     */
    this.configData = this.removeDuplicateSelectionItem(this.configData);
    this._widgetData = this.destructureFormData(this.configData);
    if (groupItmChanged) {
      this.mapData(this._widgetData);
      groupItmChanged = false;
    }

    // Handling restriction of the endIndex of the table when items are dragged and dropped between tables
    for (let i = 0; i < this.configData.length; i++) {
      if (this.configData[i].length > this.formItems[i].widgetPayload.endIndex) {
        this.mapData(this._widgetData);
      }
    }

    this.emitUpdate();
  }

  destructureFormData(configData) {
    // Assigning priorityIndex for the items and destructuring to update
    const tablesData = configData;
    let widgetData = [];
    //this._widgetData.length = 0;
    let priorityIndex = null;
    /**
     * First level tables -- loaded from html
     */
    tablesData.forEach((tableData, tablesDataIndex) => {
      /**
       * Nested tables -- loaded virtually via widget
       */
      tableData.forEach( (nestedData, groupIndex) => {

        if (tablesDataIndex === 1 || tablesDataIndex > 1) {
          if (Array.isArray(nestedData)) {
            nestedData[0].priorityIndex = tablesData[tablesDataIndex - 1].length + groupIndex;
          }
        } else {
          if (Array.isArray(nestedData)) {
            nestedData[0].priorityIndex = groupIndex;
          }
        }

        nestedData.forEach((newData, index) => {
          if (index > 0) {
            newData.priorityIndex = priorityIndex;
          } else {
            priorityIndex = newData.priorityIndex;
          }
          if (newData !== undefined && newData !== null && newData !== '') {
            const currentPriorityIndex = newData.priorityIndex;
            // Extra checking and resetting hiddenFormItems
            if(this.hiddenFormItems && this.hiddenFormItems.length > 0 ) {
              Object.keys(this.hiddenFormItems[0]).forEach(key => {
                if(!newData[key]){
                  newData[key] = this.hiddenFormItems[0][key]
                }
              });
            }
            if(!newData.priorityIndex){
              newData.priorityIndex = currentPriorityIndex;
            }
            widgetData.push(newData);
          }
        });
      });
    });
    return widgetData;
  }

  emitUpdate() {
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this._widgetData]);
    }
  }

  updateLastItems(event) {
    this.newItem = event.form;
    let flag=false;
    if(this.addFormConfig) {
      this.addFormConfig.map((formItems) => {
        if (this.newItem[formItems.name]) {
          if (formItems.type.toLowerCase() === "datepicker") {
            if (formItems.defaultValue === "now") {
              const today: any = new Date();
              if (this.newItem[formItems.name] !== today.toPlatformFormat())
                flag = true;
            } else
              flag = true;
          } else if (typeof (this.newItem[formItems.name]) === "object" && !isEqual(formItems.defaultValue, this.newItem[formItems.name]))
            flag = true;
          else if (typeof (this.newItem[formItems.name]) !== "object" && (formItems.type.toLowerCase() !== "datepicker") && formItems.defaultValue !== this.newItem[formItems.name])
            flag = true;
        }
      })
    }
    this._groupingService.notifyDataUpdated(flag);
  }

  addItem() {
    this.submitted = true;
    if (!this.isValid) {
      return;
    } else {
      this._widgetData = this._widgetData || [];

      if (this.newItem !== null) {
        if (this.group.groupBy[0] === UNIQUEPARAM) {
          const uniqueParam = new Date().getTime();
          const uniqueParamObj = this.normalizeValue(uniqueParam);
          set(this.newItem,[UNIQUEPARAM],uniqueParamObj);
        }
        this._widgetData.push(this.newItem);
        this.mapData(this._widgetData);
        this.newItem = null;
        this.reset = true;
        this.addFormEditMode = false;
        this.submitted = false;
        this._groupingService.notifyDataUpdated(false);
        this._changeDetector.markForCheck();
        this._changeDetector.detectChanges();
      }
    }
  }

  normalizeValue(value){
    const transformedValue = {"code":value,"display":value};
    return transformedValue;
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }

  public deleteItem(eventData) {
    if (! eventData) { return; }

    const deletedItem = eventData.item;

    // Handling two types of delete
    // Handling delete item which is not saved yet
    if ((deletedItem['id'] === undefined && deletedItem['meta'] === undefined) || this.enableHardDelete ) {
      const index = this._widgetData.findIndex(dataItem => dataItem === eventData.item);
      this._widgetData.splice(index, 1);
    } else {
      // Handling delete item which is already saved
      deletedItem[PriorityTableComponent.TAG_DELETED] = true;
    }
    this.mapData(this._widgetData);
  }

  public getPriorityTableItemNgClass(itemDetails) {
    // Applying strike through styles for the deleted item
    let deletedItem = { };
    itemDetails.forEach( (item) => {
      if (item && item[PriorityTableComponent.TAG_DELETED] && item[PriorityTableComponent.TAG_DELETED] === true) {
        item[PriorityTableComponent.TAG_DELETED] = true;
        deletedItem = item;
        Object.defineProperty(item, DynamicFormTableComponent.ITEM_SPECIFIC_NG_CLASS_PROPRTY, {
          value: this.itemNgClass(deletedItem), enumerable: false,
          configurable: true
        });
      }
    });

    return null;
  }

  itemNgClass (item: any) {
    let ngClass;
    if (item.deleted === true) {
      ngClass = { 'dynamic-form-item-deleted': true};
    }

    if (! ngClass) {
      ngClass = { };
    }

    return ngClass;
  }

  private buildWidgetConfiguration(_itemConfig) {
    this.formItems = [];
    for (let index = 0; index  < _itemConfig.widgetPayload.tablesConfig.length ; index++) {
      const item = _itemConfig.widgetPayload.tablesConfig[index];
      const config = DynamicFormItem.builder('', 'FirstTableClone', ITEMS_TYPES.WIDGET)
        .setComponentToLoad('DynamicFormTableComponent')
        .setWidgetPayload({
          formVertical: item.formVertical,
          tableTitle: item.title,
          prioritizeTrackByField: item.prioritizeTrackByField,
          startIndex: item.startIndex,
          endIndex: item.endIndex,
          skipAsyncValidation: true,
          skipInit:true,
          emitFormChangeEvenIfInvalid:true,
          skipWidgetUpdateValueCallback: true,
          formConfig: [
            DynamicFormItem.builder('', '#FirstTableClone', ITEMS_TYPES.WIDGET)
              .setComponentToLoad('DynamicFormTableComponent')
              .setWidgetPayload({
                formVertical: !item.formVertical,
                defaultTabletitle:[],
                showDeleteButton: item.showDeleteButton,
                deleteAvailableByField: item.deleteAvailableByField,
                deleteFieldModelName: item.deleteFieldModelName,
                cloneAvailable: item.cloneAvailable,
                formId: get(_itemConfig, 'widgetPayload.itemFormId'),
                skipAsyncValidation: true,
                skipInit:true,
                emitFormChangeEvenIfInvalid:true,
                skipWidgetUpdateValueCallback: true
              })]
        });

      this.formItems.push(config);
    }

  }

  private removeDuplicateSelectionItem(configData) {
    let modifiedData = [];
    let data = [];

    if(!isEmpty(get(configData,'0'))) {
      modifiedData[0] = this.removeNestedSelectionItem(configData[0], []);
      data[0] = modifiedData[0].modifiedArrayItems;
    }
    if(!isEmpty(get(configData,'1'))) {
      modifiedData[1] = this.removeNestedSelectionItem(configData[1], modifiedData[0].uniqueSelectionIds);
      data[1] = modifiedData[1].modifiedArrayItems;
    }

    return data;
  }

  private removeNestedSelectionItem(arrayItems, uniqueSelectionIds) {
    let modifiedArrayItems = arrayItems;
    let count = 0;
    arrayItemsLoop:
      for(let arrayIndex = 0; arrayIndex < arrayItems.length; arrayIndex++){
        let arrayItem = arrayItems[arrayIndex];
        arrayItemLoop:
          for(let itemIndex = 0; itemIndex < arrayItem.length; itemIndex++) {
            let item = arrayItem[itemIndex];
            if(!item.hasOwnProperty(selectionListId)) {
              if(itemIndex == 0 && arrayItem.length > 1){
                continue;
              }
              else {
                break arrayItemsLoop;
              }
            }
            if(uniqueSelectionIds.includes(item[selectionListId])){
              count = 0;
              remove(modifiedArrayItems[arrayIndex], (element) => {
                if(item[selectionListId] === element[selectionListId] && count == 0){
                  count++;
                  return true;
                }
              });
              break arrayItemsLoop;
            }
            else if(item[selectionListId]) {
              uniqueSelectionIds.push(item[selectionListId]);
            }
          }
      }

    if(count == 1) {
      remove(modifiedArrayItems, (element) => {
        return isEmpty(element);
      });
    }
    return {
      modifiedArrayItems, uniqueSelectionIds
    };
  }

}


export interface PriorityTablePayload {
  enableHardDelete: boolean;
  itemFormId: string;
  appendFormId: string;
  editMode: boolean;
  popupMode: boolean;
  formConfig: any;
  formVertical: boolean;
  listenToDataChange: boolean;
  prioritizeAvailable: boolean;
  tablesConfig: Array<PriorityTableNestedPayload>;
  isExternal: boolean;
}

export interface PriorityTableNestedPayload {
  tableTitle: string;
  formVertical: boolean;
  startIndex: number;
  endIndex: number;
  listName: string;
  showDeleteButton: boolean;
  deleteAvailableByField: string;
  cloneAvailable: boolean;
  prioritizeTrackByField: string;
  formConfig: FormConfigPayload;
}

export interface FormConfigPayload {
  formId: string;
  formConfig: any;
}


class PriorityTableValidator implements AsyncValidator {
  constructor(private validationCallback: () => boolean) {

  }
  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return  this.validationCallback()
      ? of (null)
      : of ({ error: true});
  }

  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }

}
